import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import type { LinkProps as NextLinkProps } from 'next/link';

const regAbsolute = /^([a-z]+:\/\/|\/\/)/i;

/**
 * Helper hook to get pathname of href if internal link and hostname included. Otherwise get complete href
 * @param {NextLinkProps['href']} href provided href for image link
 */
export const useClearedHref = (href: NextLinkProps['href']) => {
  const {
    host: { domain },
  } = useConfig();
  const tenantHost = `www.${domain}`;
  let linkHref = typeof href === 'string' ? href : (href.pathname ?? '/');
  let external = false;

  // if href string, check  if absolute url
  if (typeof href === 'string') {
    if (regAbsolute.test(href)) {
      // if protocol-relative-url, add protocol
      const absoluteHref = href.startsWith('//') ? `https:${href}` : href;
      const { hostname: hostNameLink } = new URL(absoluteHref);
      const hostNameClient = typeof window !== 'undefined' ? window?.location?.hostname : undefined;

      // if host equals testing systems or tenant domain, it is an internal link, but set linkhref to pathname
      if (
        [tenantHost, hostNameClient, 'localhost'].some(
          (testHost) => testHost && hostNameLink.indexOf(testHost) > -1,
        )
      ) {
        // TODO: check if it is a requirement that query params are not in linkHref
        linkHref = new URL(absoluteHref).pathname;
      } else {
        external = true;
      }
    }
    // if href urlObject, che ck if host exists
  } else if (href.host) {
    // if host does not equal to tenant domain, it is an external link
    if (href.host.indexOf(tenantHost) === -1) {
      linkHref = href.href ?? '/';
      external = true;
    }
  }

  return { linkHref, external };
};
